 $(function() {
   $("#ContactFooter").parent().parent().parent().addClass("newsletterWrapper");
   var our_story = $('.text_slider_inner');
   our_story.on('init', function(event, slick){
        $('.arrow_box').prepend('<div class="slider-count"><p><span id="current">1</span> / <span id="total">'+slick.slideCount+'</span><span class="next_item"> > </spna></p></div>');
    });
      our_story.slick({
        dots: true,          
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows : false
      });
       our_story.on('afterChange', function(event, slick, currentSlide, nextSlide){           
            $('.slider-count #current').html(currentSlide+1);
        });
   
   $('body').on('click', '.next_item', function(){
     our_story.slick('slickNext');
   });
   
   $('.featured_box').slick({
        dots: false,        
        infinite: false,
        arrows : true,
     	infinite: true,
    	slidesToShow: 2,
    	variableWidth: true,
     	 
            responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }
     	]
   });
   
   
   $(".image_slick_slider").slick({
     dots: false,
     arrows: false,
     slidesToShow: 1,
     slidesToScroll: 1,
     asNavFor: '.slick_slider_nav'
   });
   $(".slick_slider_nav").slick({
     dots: false,
     arrows: false,
     slidesToShow: function(){ return $(".slick_slider_nav li").length; },
     slidesToScroll: 1,
     asNavFor: '.image_slick_slider'
   });
   $(".image_slider .slideCount span").text( "1/" + $(".slick_slider_nav li").length + ">");
   $('.image_slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
  		$(".image_slider .slideCount span").text( (currentSlide+1) + "/" + $(".slick_slider_nav li").length + ">");
	});
   
   
   $(".article-list.slick-slider").slick({
     dots: true,
     infinite: true,
     arrows: false,
     slidesToShow: 3,
     slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 768,
         settings: "unslick"
            
          }
        
     	]
   });
   
   if($(window).width() < 769) {
     if($(".circle-row").length > 0) {
       $(".circle-row .colmn_set").each(function(index){
         if(index > 5) {
           $(this).css({"display":"none"});
         }
       });
     }
   }
   
   if($(window).width() < 768) {
     if($(".ingredient-articles .article-list").length > 0) {
       $(".ingredient-articles .article-list li").each(function(index){
         if(index > 3) {
           $(this).css({"display":"none"});
         }
       });
     }
   }
   
   
   
   $('.pdt_sign').on('click', function(){
      var qty = parseInt($('[data-quantity-input]').val());
     console.log(qty);
     if($(this).hasClass('pdt_minis')){
       qty -=1;
     }else{
       qty +=1;
     }
     console.log(qty);
     
     if(qty > 0){
        $('[data-quantity-input]').val(qty);
     }
     
   });
   
});

document.addEventListener("DOMContentLoaded", function() {
    if($("ul.grid--blog").length > 0) {
      console.log("X1");
      var endlessScroll = new Ajaxinate({
        container: '#blogGrid',
        pagination: '#blog-loadmore',
        method: 'click'
      });
    }
  });

$("body").on("click", "#loadCircle span", function(){
  $(".circle-row .colmn_set").css({"display":"block"});
  $("#loadCircle").hide();
});

$("body").on("click", "#loadArticle span", function(){
  $(".ingredient-articles .article-list li").css({"display":"block"});
  $("#loadArticle").hide();
});

var x = setInterval(function(){
  if($("#email_address_field_0").length > 0) {
    $("<div class='fieldWrapper'>").insertBefore("#email_address_field_0");
    $("#first_name_field_0").appendTo(".fieldWrapper");
    $("#last_name_field_0").appendTo(".fieldWrapper");
    $("#email_address_field_0").appendTo(".fieldWrapper");
    
    
    //$("#last_name_field_0").insertBefore("#email_address_field_0");
    //$("#first_name_field_0").insertBefore("#last_name_field_0");
    clearInterval(x);
  }
}, 500);

$(window).on("load", function(){
   AOS.init({
     duration: 500,
     offset: 50,
     delay: 50
   });
})